// 设置语言
export const SET_LANG = 'SET_LANG'
export const SET_START_TIME = 'SET_START_TIME'
export const SET_END_TIME = 'SET_END_TIME'
export const ADD_CREDIT = 'ADD_CREDIT'
export const SET_USER = 'SET_USER'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js